import { authAxios } from '@shared/api/auth-instance'
import { URLS } from '@assets/environment/urls'
import { Training } from '@entities/training'

export class ProgramExecutionProxy {
	public static readonly BASE_URL: string = `${URLS.WORKOUT}programs`

	public static startDay = async (params: {
		enrollment_id: number
		week_num: number
		day_num: number
	}): Promise<Training | null> => {
		try {
			const response = await authAxios.post<Training>(this.BASE_URL + '/days/start', params)
			console.log('Start day response', response.data)
			return response.data
		} catch (e: unknown) {
			console.log('Error while starting day in program', e)
			return null
		}
	}

	public static skipDay = async (params: {
		enrollment_id: number
		week_num: number
		day_num: number
	}): Promise<boolean> => {
		try {
			const response = await authAxios.post(this.BASE_URL + '/days/skip', params)
			console.log('Skip day response', response.data)
			return true
		} catch (e: unknown) {
			console.log('Error while skipping day in program', e)
			return false
		}
	}

	public static completeDay = async (params: {
		enrollment_id: number
		week_num: number
		day_num: number
	}): Promise<boolean> => {
		try {
			const response = await authAxios.post(this.BASE_URL + '/days/complete', params)
			console.log('Start day response', response.data)
			return true
		} catch (e: unknown) {
			console.log('Error while starting day in program', e)
			return false
		}
	}
}
